export default __webpack_public_path__ + "static/media/flayerAA.e362dadc.jpg";